import React, {useState} from 'react'
import {AppBarInboxQuery, ProcessTableQuery, ProfileInfoQuery} from '../../organism'
import {useAppContext} from "../../../context/appContext";
import { isArcosDorados } from '../../../utils/clientHelpers'

const InboxPeopleQuery = ({
                            classes,
                            i18n,
                          }) => {

  const [rowsSelected, setRowsSelected] = useState([]);
  const [isOpenModalSuggestChangeStatus, setIsOpenModalSuggestChangeStatus] = useState(false);
  const [tableRef, setTableRef] = useState(null);

  const filterName = isArcosDorados()
    ? i18n.appBar.filterPeopleAD
    : i18n.appBar.filterPeople;

  const filters = useAppContext();
    return (
      <div className={classes.root}>
        <AppBarInboxQuery
          showActions
          filterName={filterName}
          filters={filters}
          rowsSelected={rowsSelected}
          setRowsSelected={setRowsSelected}
          tableRef={tableRef}
          section={"inboxPeople"}
        />

        <ProcessTableQuery
          title={i18n.inboxPeople.title}
          filters={filters}
          updateParentRowsSelected={setRowsSelected}
          showChangeStatus
          suggestChangeStatusModal={{ isOpenModalSuggestChangeStatus, setIsOpenModalSuggestChangeStatus}}
          setTableRef={setTableRef}
          rowViewRender={id => <ProfileInfoQuery id={id} />}
        />
      </div>
    )
}

export default InboxPeopleQuery
